import Image from 'next/image';
import Link from '@eliadmin/core/src/components/link';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { FiArrowRight } from 'react-icons/fi';

export type ProfileSidebarItemProps = {
  name: string;
  icon: string;
  variant?: any;
  href: string | (() => string);
  hardLink?: boolean;
  pathname: string;
};

export const ProfileSidebarItem = ({
  name,
  icon,
  variant,
  hardLink,
  href,
}: ProfileSidebarItemProps) => {
  const LinkComponent = hardLink ? 'a' : Link;
  const hrefString = typeof href === 'function' ? href() : href;

  return (
    <LinkComponent
      key={hrefString + name}
      href={hrefString ?? '#'}
      className={cn(
        'flex h-14 cursor-pointer items-center justify-center gap-3 rounded-[12px] border border-border bg-transparent px-4 text-black transition-all hover:border-[#FFFACC] hover:bg-[#FFFACC] hover:text-black sm:h-16',
      )}
    >
      <Image src={icon} alt={name} width={32} height={32} className="shrink-0 object-contain" />
      <span className="flex-1 text-sm font-semibold tracking-tight sm:text-base">{name}</span>
      {variant !== 'destructive' && <FiArrowRight size={20} className="text-primary" />}
    </LinkComponent>
  );
};
